module.exports = __webpack_public_path__ + "img/v_logo.3fc43da0.png";